import { render, staticRenderFns } from "./MembersGold.vue?vue&type=template&id=3703c5ce&scoped=true&"
import script from "./MembersGold.vue?vue&type=script&lang=js&"
export * from "./MembersGold.vue?vue&type=script&lang=js&"
import style0 from "./MembersGold.vue?vue&type=style&index=0&id=3703c5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703c5ce",
  null
  
)

export default component.exports